import { addThousandSeparatorToStr } from "../../../../lib/number";

export const formatPrice = (number: number, dp: number = 2): string => {
	// Handle zero case with dynamic precision based on `dp`
	if (number === 0) return "0" + (dp > 0 ? "." + "0".repeat(dp) : "");

	const [integerPart, decimalPart = ""] = number.toString().split(".");

	// Truncate the decimal part by slicing, and pad if needed
	const truncatedDecimalPart = decimalPart.slice(0, dp).padEnd(dp, "0");

	// Combine integer part with decimal part and add thousand separators
	return addThousandSeparatorToStr(
		integerPart + (dp > 0 ? "." + truncatedDecimalPart : ""),
	);
};
